import axios from "axios";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import { initialConverstionRateFilterData } from "../../utils/initialData";
import ConverstionRateFilter from "./ConverstionRateFilter";

const ConversationRate = () => {
  const [config] = useAuth();
  const [data, setData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState(() => {
    const localFilterData = localStorage.getItem("filterData");
    return localFilterData ? JSON.parse(localFilterData) : initialConverstionRateFilterData;
  });

  const stages = [
    "Lead to BOV",
    "BOV to Exclusive",
    "Buyer Lead to Buyer Initial Offer",
    "Seller Lead to Seller Initial Offer",
    "Exclusives to Initial Offer",
    "Initial Offer to Executed LOI",
    "Buyer Initial Offer to Executed LOI",
    "Seller Initial Offer to Executed LOI",
    "Executed LOI to UC",
    "Buyer Executed LOI to UC",
    "Seller Executed LOI to UC",
    "UC to Closed",
    "Buyer UC to Closed",
    "Seller UC to Closed",
  ];

  const keyMap = {
    "Lead to BOV": "lead_to_bov",
    "BOV to Exclusive": "bov_to_exclusive",
    "Buyer Lead to Buyer Initial Offer": "buyer_lead_to_buyer_initial_offer",
    "Seller Lead to Seller Initial Offer": "seller_lead_to_seller_initial_offer",
    "Exclusives to Initial Offer": "exclusives_to_initial_offer",
    "Initial Offer to Executed LOI": "initial_offer_to_executed_loi",
    "Buyer Initial Offer to Executed LOI": "buyer_initial_offer_to_executed_loi",
    "Seller Initial Offer to Executed LOI": "seller_initial_offer_to_executed_loi",
    "Executed LOI to UC": "executed_loi_to_uc",
    "Buyer Executed LOI to UC": "buyer_executed_loi_to_uc",
    "Seller Executed LOI to UC": "seller_executed_loi_to_uc",
    "UC to Closed": "uc_to_closed",
    "Buyer UC to Closed": "buyer_uc_to_closed",
    "Seller UC to Closed": "seller_uc_to_closed",
  };


  const buildQueryParams = (filters = {}) => {
    let params = `page=${currentPage}&per_page=${itemPerPage}`;

    const { created_start_date, created_end_date, created_at, bds } = filters;

    if (created_start_date) params += `&created_start_date=${encodeURIComponent(created_start_date)}`;
    if (created_end_date) params += `&created_end_date=${encodeURIComponent(created_end_date)}`;
    if (created_at) params += `&created_at=${encodeURIComponent(created_at)}`;
    if (bds !== undefined) {
      params += `&bds=${encodeURIComponent(bds)}`; // ⚠️ also fix here
    }

    localStorage.setItem("queryParams", params);

    return params;
  };

  // ✅ Axios API function
  const fetchConversionRates = (filters) => {
    setLoading(true);
    const queryParams = buildQueryParams(filters);
    axios
      .get(`${BASE_URL}/conversion-rates?${queryParams}`, {
        ...config,
        params: { show_user_id: 10 }, // ✅ better way with axios
      })
      .then((res) => {
        setData(res.data?.data || {});
      })
      .catch((err) => {
        console.error("API Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchConversionRates();
  }, []);

  useEffect(() => {
    onSuccess();
  }, [currentPage, itemPerPage,]);

  const onSuccess = (filters) => {
    setLoading(true);
    if (filters) {
      fetchConversionRates(filters);
    } else {
      fetchConversionRates(filterData);
    }
  };

  return (
    <BaseLayout>
      <div className="">
        <div className="flex gap-8 items-baseline">
          <div>
            <h2 className="head-1 dark-H mb-4">Conversion Rates</h2>
          </div>

          <div>
            <ConverstionRateFilter
              filterData={filterData}
              onSetFilterData={(value) => {
                setFilterData(value);
              }}
              from="converstionrate"
              onCallApiAgain={(filters) => onSuccess(filters)}
            />
          </div>

        </div>


        <div>
          {loading ? (
            <div className="text-center py-10">Loading...</div>
          ) : (
            <table className="w-full light-bg-L pb-3 table-container">
              <thead>
                <tr>
                  <th className="py-3 px-5 text-left">Stage</th>
                  <th className="py-3 px-5 text-right">Rate</th>
                </tr>
              </thead>

              <tbody>
                {stages.map((stage) => {
                  const value = data[keyMap[stage]];

                  return (
                    <tr key={stage} className="border-t">
                      <td className="py-3 px-5 head-5 ">{stage}</td>
                      <td className="py-3 px-5 text-right body-S">
                        {value || "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

      </div>
    </BaseLayout>
  );
};

export default ConversationRate;